/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    SlackChannel,
    SlackChannelFromJSON,
    SlackChannelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SlackWorkspaceInfo
 */
export interface SlackWorkspaceInfo {
    /**
     * 
     * @type {string}
     * @memberof SlackWorkspaceInfo
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof SlackWorkspaceInfo
     */
    teamName: string;
    /**
     * 
     * @type {string}
     * @memberof SlackWorkspaceInfo
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof SlackWorkspaceInfo
     */
    botUserId: string;
    /**
     * 
     * @type {Array<SlackChannel>}
     * @memberof SlackWorkspaceInfo
     */
    channels: Array<SlackChannel>;
}

export function SlackWorkspaceInfoFromJSON(json: any): SlackWorkspaceInfo {
    return {
        'teamId': json['teamId'],
        'teamName': json['teamName'],
        'accessToken': json['accessToken'],
        'botUserId': json['botUserId'],
        
        'channels': (json['channels'] as Array<any>).map(SlackChannelFromJSON),
        
    };
}

export function SlackWorkspaceInfoToJSON(value?: SlackWorkspaceInfo): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'teamId': value.teamId,
        'teamName': value.teamName,
        'accessToken': value.accessToken,
        'botUserId': value.botUserId,
        
        'channels': (value.channels as Array<any>).map(SlackChannelToJSON),
        
    };
}


